import { render, staticRenderFns } from "./modalShare.vue?vue&type=template&id=3061ceb7&scoped=true&"
import script from "./modalShare.vue?vue&type=script&lang=js&"
export * from "./modalShare.vue?vue&type=script&lang=js&"
import style0 from "./modalShare.vue?vue&type=style&index=0&id=3061ceb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3061ceb7",
  null
  
)

export default component.exports